function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var FieldTemplate = require('./field.template');
var FieldOverlay = /*#__PURE__*/function () {
  function FieldOverlay(app, mod) {
    _classCallCheck(this, FieldOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.overlay["class"] = 'saito-overlay saitosign-overlay';
    this.hooks = {};
  }
  return _createClass(FieldOverlay, [{
    key: "render",
    value: function render(view) {
      var _this = this;
      var hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.hooks = hooks;
      this.view = view;
      this.overlay.show(FieldTemplate(view), function () {
        _this.unbindKeys();
        if (_this.hooks.onClose) {
          _this.hooks.onClose();
        }
      });
      this.attachEvents();
      this.bindKeys();
    }
  }, {
    key: "close",
    value: function close() {
      this.unbindKeys();
      this.overlay.close();
    }
  }, {
    key: "bindKeys",
    value: function bindKeys() {
      var _this2 = this;
      this.unbindKeys();
      this.onKeyDown = function (event) {
        var form = document.querySelector('.saitosign-field');
        if (!form || !form.isConnected || event.isComposing) {
          return;
        }
        var target = event.target;
        if (target && target.closest && target.closest('.saito-overlay-closebox')) {
          return;
        }
        if (event.key === 'Delete') {
          var _this2$view, _this2$view2;
          if (isTypingTarget(target) || !((_this2$view = _this2.view) !== null && _this2$view !== void 0 && _this2$view.existing) || !((_this2$view2 = _this2.view) !== null && _this2$view2 !== void 0 && _this2$view2.editable) || !_this2.hooks.onRemove) {
            return;
          }
          if (form.dataset.deleting === '1') {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          form.dataset.deleting = '1';
          Promise.resolve(typeof sconfirm === 'function' ? sconfirm('Delete this?') : window.confirm('Delete this?')).then(function (confirmed) {
            if (confirmed && _this2.hooks.onRemove) {
              _this2.hooks.onRemove();
            }
          })["finally"](function () {
            form.dataset.deleting = '';
          });
          return;
        }
        if (event.key !== 'Enter') {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', {
            cancelable: true,
            bubbles: true
          }));
        }
      };
      document.addEventListener('keydown', this.onKeyDown, true);
    }
  }, {
    key: "unbindKeys",
    value: function unbindKeys() {
      if (!this.onKeyDown) {
        return;
      }
      document.removeEventListener('keydown', this.onKeyDown, true);
      this.onKeyDown = null;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this,
        _form$querySelector2,
        _form$querySelector3;
      var form = document.querySelector('.saitosign-field');
      if (!form) {
        return;
      }
      var signer_select = form.querySelector('[data-field-signer]');
      var type_select = form.querySelector('[data-field-type]');
      var extra = form.querySelector('.new-signer');
      var refreshMode = function refreshMode() {
        var button = form.querySelector('.actions button.primary');
        var view = _this3.view;
        if (!button || !(view !== null && view !== void 0 && view.can_sign)) {
          return;
        }
        var type = type_select === null || type_select === void 0 ? void 0 : type_select.value;
        var chosen = signer_select.value;
        var sign = !view.already_signed && (type === 'signature' || type === 'initial') && chosen === String(view.sign_index);
        button.textContent = sign ? 'Sign' : 'Confirm';
        button.dataset.mode = sign ? 'sign' : 'confirm';
      };
      var preview = function preview() {
        if (_this3.hooks.onPreview) {
          _this3.hooks.onPreview(form);
        }
      };
      var refreshDisclosure = function refreshDisclosure() {
        var ready = signerReady(form);
        var what = form.querySelector('.what');
        if (what) {
          what.hidden = !ready;
        }
        if (type_select && !ready) {
          type_select.value = '';
        }
        refreshDetails(form);
        refreshMode();
        preview();
      };
      signer_select.addEventListener('change', function () {
        extra.hidden = signer_select.value !== 'new';
        showError(form, '');
        refreshDisclosure();
        if (!extra.hidden) {
          var _form$querySelector;
          (_form$querySelector = form.querySelector('[data-signer-name]')) === null || _form$querySelector === void 0 || _form$querySelector.focus();
        }
      });
      (_form$querySelector2 = form.querySelector('[data-signer-name]')) === null || _form$querySelector2 === void 0 || _form$querySelector2.addEventListener('input', function () {
        showError(form, '');
        refreshDisclosure();
      });
      (_form$querySelector3 = form.querySelector('[data-signer-email]')) === null || _form$querySelector3 === void 0 || _form$querySelector3.addEventListener('input', function () {
        showError(form, '');
        refreshDisclosure();
      });
      type_select === null || type_select === void 0 || type_select.addEventListener('change', function () {
        showError(form, '');
        refreshDetails(form);
        refreshMode();
        preview();
      });
      if (!extra.hidden) {
        var _form$querySelector4;
        (_form$querySelector4 = form.querySelector('[data-signer-name]')) === null || _form$querySelector4 === void 0 || _form$querySelector4.focus();
      }
      var remove = form.querySelector('[data-remove-field]');
      if (remove) {
        remove.onclick = function () {
          if (_this3.hooks.onRemove) {
            _this3.hooks.onRemove();
          }
        };
      }
      var commit = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          var _form$querySelector5;
          var mode, problem, saved, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                event.preventDefault();
                if (!(form.dataset.saving === '1')) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                form.dataset.saving = '1';
                mode = (_form$querySelector5 = form.querySelector('.actions button.primary')) === null || _form$querySelector5 === void 0 ? void 0 : _form$querySelector5.dataset.mode;
                if (!(mode !== 'sign')) {
                  _context.n = 2;
                  break;
                }
                problem = validateFieldForm(form);
                if (!problem) {
                  _context.n = 2;
                  break;
                }
                showError(form, problem);
                form.dataset.saving = '';
                return _context.a(2);
              case 2:
                showError(form, '');
                saved = false;
                _context.p = 3;
                if (!(mode === 'sign' && _this3.hooks.onSign)) {
                  _context.n = 5;
                  break;
                }
                _context.n = 4;
                return _this3.hooks.onSign();
              case 4:
                saved = _context.v;
                _context.n = 6;
                break;
              case 5:
                if (_this3.hooks.onSave) {
                  saved = _this3.hooks.onSave(form);
                }
              case 6:
                _context.n = 8;
                break;
              case 7:
                _context.p = 7;
                _t = _context.v;
                saved = false;
              case 8:
                if (!saved) {
                  form.dataset.saving = '';
                }
              case 9:
                return _context.a(2);
            }
          }, _callee, null, [[3, 7]]);
        }));
        return function commit(_x) {
          return _ref.apply(this, arguments);
        };
      }();
      form.addEventListener('submit', commit);
      var place = form.querySelector('.actions button.primary');
      if (place) {
        place.addEventListener('click', commit);
      }
    }
  }]);
}();
function signerReady(form) {
  var _form$querySelector6;
  var chosen = (_form$querySelector6 = form.querySelector('[data-field-signer]')) === null || _form$querySelector6 === void 0 ? void 0 : _form$querySelector6.value;
  if (chosen === 'new') {
    var _form$querySelector7, _form$querySelector8;
    var name = ((_form$querySelector7 = form.querySelector('[data-signer-name]')) === null || _form$querySelector7 === void 0 ? void 0 : _form$querySelector7.value.trim()) || '';
    var email = ((_form$querySelector8 = form.querySelector('[data-signer-email]')) === null || _form$querySelector8 === void 0 ? void 0 : _form$querySelector8.value.trim()) || '';
    return Boolean(name && isEmailAddress(email));
  }
  return chosen !== '' && chosen != null;
}
function refreshDetails(form) {
  var _form$querySelector9;
  var details = form.querySelector('[data-field-details]');
  var every = form.querySelector('[data-every-page]');
  var type = (_form$querySelector9 = form.querySelector('[data-field-type]')) === null || _form$querySelector9 === void 0 ? void 0 : _form$querySelector9.value;
  var typeSelect = form.querySelector('[data-field-type]');
  var what = form.querySelector('.what');
  var allow = Boolean(every) && !(what !== null && what !== void 0 && what.hidden) && (type === 'signature' || type === 'initial');
  if (!details) {
    return;
  }
  details.hidden = !allow;
  if (!allow && every) {
    every.checked = false;
  }
}
function validateFieldForm(form) {
  var _form$querySelector0;
  var chosen = (_form$querySelector0 = form.querySelector('[data-field-signer]')) === null || _form$querySelector0 === void 0 ? void 0 : _form$querySelector0.value;
  if (chosen === 'new') {
    var _form$querySelector1, _form$querySelector10;
    var name = ((_form$querySelector1 = form.querySelector('[data-signer-name]')) === null || _form$querySelector1 === void 0 ? void 0 : _form$querySelector1.value.trim()) || '';
    var email = ((_form$querySelector10 = form.querySelector('[data-signer-email]')) === null || _form$querySelector10 === void 0 ? void 0 : _form$querySelector10.value.trim()) || '';
    if (!name || !email) {
      return 'Enter a name and email for the new signer.';
    }
    if (!isEmailAddress(email)) {
      return 'Enter a valid email address.';
    }
  } else if (chosen === '' || chosen == null) {
    return 'Choose who this field is for.';
  }
  var what = form.querySelector('.what');
  var typeSelect = form.querySelector('[data-field-type]');
  if (!typeSelect || what !== null && what !== void 0 && what.hidden) {
    return 'Choose who this field is for before selecting a field type.';
  }
  var type = typeSelect.value;
  if (type !== 'signature' && type !== 'date' && type !== 'initial') {
    return 'Please choose what this user should do.';
  }
  return '';
}
function showError(form, message) {
  var slot = form.querySelector('[data-form-error]');
  if (!slot) {
    return;
  }
  slot.hidden = !message;
  slot.textContent = message || '';
}
function isEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}
function isTypingTarget(target) {
  if (!target) {
    return false;
  }
  if (typeof target.matches === 'function' && target.matches('input, textarea, select')) {
    return true;
  }
  return Boolean(target.closest && target.closest('input, textarea, select'));
}
module.exports = FieldOverlay;